<template>
  <span class="user-identity">
    <UserAvatar :user="user" :size="size" />
    <span class="user-identity-name">
      <slot>{{ userDisplayName(user) }}</slot>
    </span>
  </span>
</template>

<script setup>
import UserAvatar from './UserAvatar.vue'
import { userDisplayName } from '../utils/userDisplay'

defineProps({
  user: {
    type: Object,
    required: true,
  },
  size: {
    type: String,
    default: 'md',
  },
})
</script>

<style scoped>
.user-identity {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.user-identity-name {
  min-width: 0;
  word-break: break-word;
}
</style>
